export default "__VITE_ASSET__Drd_my0i__"